
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplaces",
      function () {
        return require("private-next-pages/marketplaces/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplaces"])
      });
    }
  